import { createFileRoute } from "@tanstack/react-router";

import { PrintersPage } from "@/features/drukarki/printers-page";
import { printersSearchSchema } from "@/features/drukarki/search";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/drukarki")({
	validateSearch: (search) => printersSearchSchema.parse(search),
	component: PrintersPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.konfiguracja.drukarki",
			location.pathname,
		);
	},
});
